import React, { Component } from "react";
import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import { setSideMenuSelectedItem, setToolbarTitle } from "../../../redux/actions";
import { releaseHome } from "../../../network/api";
import Adapter from "./home-adapter";
import Loading from "../../util/page-loading";
import logoVector from "../../../resources/image/release_vector.jpg";

class Releases extends Component {
  state = {
    pageTitle: "ریلیزها",
    pageTag: "releases",
    data: null
  };

  componentDidMount() {
    this.props.setSideMenuSelectedItem(this.state.pageTag);
    this.props.setToolbarTitle(this.state.pageTitle);
    document.title = this.state.pageTitle;
    this.callReleaseHomeApi()
  }

  render() {
    return (
      <div className="fragment text-center">
        <div >
          {(this.state.data === undefined || this.state.data === null) && <Loading />}

          {this.state.data !== undefined && this.state.data !== null && this.state.data.length !== 0 && (
            <div>

              <div className="app-card mx-auto mb-5" >
                <img
                  className="col-3 col-sm-3 col-md-2 col-lg-2 col-xl-1"
                  src={logoVector}
                  alt=""
                />

                <div style={{ fontSize: 18, color: "black" }}>آخرین وضعیت ریلیزها</div>
                <div style={{ fontSize: 14, color: "dimgray", marginTop: 16, marginBottom: 24 }}>در این بخش میتوانید به آخرین نسخه و اطلاعات ریلیزهای پلتفرمهای مختلف ویپاد دسترسی داشته باشید.</div>
              </div>

              {this.state.data.map((item) => (
                <Adapter
                  key={item.id}
                  item={item}
                />
              ))}
            </div>
          )}
        </div>
      </div>
    );
  }

  /****
  ** NETWORK
  *****/

  callReleaseHomeApi() {
    this.setState({ loading: true })
    releaseHome(this.handleReleaseHomeApiSuccess, this.handleReleaseHomeFailure);
  }

  handleReleaseHomeApiSuccess = (data) => {
    this.setState({
      loading: false,
      data: data
    });
  };

  handleReleaseHomeFailure = (error) => {
    this.setState({ loading: false });
  }

}

//// REDUX STUFF
function mapStateToProps(state) {
  return {
    login: state.login,
    profile: state.profile,
  };
}

function matchDispatchToProps(dispatch) {
  return bindActionCreators({ setSideMenuSelectedItem: setSideMenuSelectedItem, setToolbarTitle: setToolbarTitle }, dispatch);
}

export default connect(
  mapStateToProps,
  matchDispatchToProps
)(Releases);
